
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm0 21.75c-5.38 0-9.75-4.37-9.75-9.75S6.62 2.25 12 2.25s9.75 4.37 9.75 9.75-4.37 9.75-9.75 9.75zm1.88-6h-.75v-4.12c0-.62-.5-1.12-1.12-1.12h-1.5c-.62 0-1.12.51-1.12 1.12s.51 1.12 1.12 1.12h.38v3h-.75c-.62 0-1.12.51-1.12 1.12s.51 1.12 1.12 1.12h3.75c.62 0 1.12-.5 1.12-1.12s-.5-1.12-1.12-1.12zM12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5S11.17 9 12 9z",
    fill: "currentColor",
    "data-name": "Layer 1"
  })));
}

export { SvgIconInfo as default };
//# sourceMappingURL=icon-info.svg.js.map
